<div class="row mb-1 mx-2 align-items-center flex-nowrap " *ngIf="supplierDoc">

    <div class="col-3 d-flex justify-content-start flex-nowrap">
        <H5 class="text-info" *ngIf="pafDocument(supplierDoc)?.Informations"
            [paftooltip]="pafDocument(supplierDoc)?.Informations" style="margin-right: 5px;">
            <i class="fas fa-info-circle"></i>
        </H5>
        <div class="flex-fill" [paflabel]="getLblCod(supplierDoc)">
        </div>
        <button *ngIf="canUpdateFile" type="button" class="btn btn-xs btn-primary" btnDebounceClick
            (debounceClick)="btnImportClick(supplierDoc)" paftooltip="Mettre_a_jour">
            <i class="fas fa-sync" [ngClass]="{'fa-pulse': importEncours}"></i>
        </button>
    </div>
    <div class="col-1">
        <button  style="width: 90px;" *ngIf="canDownloadTemplate" type="button" class="btn btn-sm btn-primary" btnDebounceClick
            (debounceClick)="btnDownloadTemplateClick(supplierDoc)">
            <paflabel lblCod="Telecharger_modele"></paflabel>&nbsp;<i class="fas fa-file-download"></i>
        </button>
    </div>
    <div class="col-2 d-flex justify-content-center">
        <button *ngIf="canDeleteFile" type="button" class="btn btn-xs btn-danger" paftooltip="Supprimer_le_fichier"
            btnDebounceClick (debounceClick)="btnDeleteFileClick(supplierDoc)">
            <i class="fa fa-trash"></i>
        </button>
        <button *ngIf="canArchiveFile" type="button" class="btn btn-xs btn-warning" paftooltip="archiver_le_fichier"
            btnDebounceClick (debounceClick)="btnArchiveFileClick(supplierDoc)">
            <i class="fas fa-archive"></i>
        </button>
        <div class="flex-shrink-0 ml-2" style="width: 95px;">
            <h6><span style="width: 100%;" [ngClass]="statutNgClass(supplierDoc)" data-toggle="tooltip"
                    [title]="popupStatut">{{getStatutLib(supplierDoc) | async}}</span></h6>
        </div>
        <button *ngIf="canAccept" type="button" class="btn btn-xs btn-success ml-1" btnDebounceClick
            (debounceClick)="validDoc(supplierDoc)" paftooltip="Valider_le_document" [disabled]="readonly"><i
                class="fas fa-clipboard-check"></i></button>
        <button *ngIf="canReject" type="button" class="btn btn-xs btn-danger ml-1" btnDebounceClick
            (debounceClick)="rejectDoc(supplierDoc)" paftooltip="Rejeter_le_document" [disabled]="readonly">
            <i class="fas fa-ban"></i>
        </button>
    </div>
    <div class="col-2 d-flex  align-items-start flex-nowrap">
        <div class="col-2" *ngIf="!!uploadProgress">
            <kendo-progressbar [value]="uploadProgress"></kendo-progressbar>
        </div>
        <label *ngIf="!uploadProgress && showExpiredLabel" class="text-danger">
            <paflabel lblCod="Expire_depuis"></paflabel> : {{supplierDateExpi}}
        </label>
        <label *ngIf="!uploadProgress && showExpireLeLabel">
            <paflabel lblCod="Expire_le"></paflabel> : {{supplierDateExpi}}
        </label>
        <div *ngIf="!uploadProgress && ShowDateInput" class="d-flex">
            <div class="mr-1 mt-1 text-info" data-delay="0" [paftooltip]="getDateTooltip(pafDocument(supplierDoc))"><i
                    class="fas fa-info-circle"></i></div>
            <label class="flex-shrink-0 mt-1" style="width:110px;"
                [paflabel]="getDateLabel(pafDocument(supplierDoc))"></label>
            <div class="flex-shrink-0" style="width:125px;">
                <kendo-datepicker name="dateInput" class="form-control" style="width:100%;" allowInput="true"  [format]="'dd/MM/yyyy'" [inputMode]="'none'"
                   [(ngModel)]="dateInput" required></kendo-datepicker>
            </div>
        </div>
    </div>
    <div class="col-1 justify-content-end">
        <div *ngIf="canUploadFile">
            <input name="fileUpload" type="file" style="width:0px;" class="file-input" [accept]="requiredFileType"
                (change)="onFileSelected($event)" #fileUpload [disabled]="readonly || !isDateValid">
            <div *ngIf="!readonly" class="file-upload">
                <button type="button" class="btn btn-sm"
                    [ngClass]="{'btn-primary':!isDownloadDisabled(), 'btn-secondary':isDownloadDisabled()}"
                    btnDebounceClick (debounceClick)="fileUpload.click()" [disabled]="isDownloadDisabled()"
                    [paftooltip]="btnUploadTooltip" draganddrop (filesDropped)="onFilesDropped($event)">
                    <paflabel lblCod="Deposer"></paflabel>&nbsp;<i class="fas fa-paperclip"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="flex-fill text-secondary align-items-center">
        <a class="flex-grow-1" *ngIf="showFileLink" href="javascript:void(0);"
            (click)="btnDownloadFileClick(supplierDoc)"
            [paftooltip]="'Telecharger_le_fichier'">{{getFilename(supplierDoc)}}</a>
    </div>
</div>
<label class="text-danger full-width text-center" *ngIf="showRibMessage" paflabel="DOC_RIB_MESSAGE"></label>